import { useIntl } from 'react-intl';
import { useLoaderData, useNavigate } from 'react-router';

import Page from 'client/components/aria/Page/Page';
import ButtonGroup from 'client/components/aria/ButtonGroup/ButtonGroup';
import Button from 'client/components/aria/Button/Button';
import styles from 'client/pages/ReaffirmationPage/ReaffirmationPage.module.scss';
import Alert from 'client/components/ui/Alert/Alert';
import Notification from 'client/components/GDS/Notification/Notification';

const ReaffirmationPage = () => {
    const { reaffirmationState } = useLoaderData();
    const intl = useIntl();
    const navigate = useNavigate();

    const handleConfirmation = () => {
        navigate(reaffirmationState.redirect);
    };

    return <Page title={intl.formatMessage({ id: 'reaffirmationPage.title' })} data-testid="reaffirmationPage">
        <div className="govuk-grid-row">
            <div className="govuk-grid-column-full" />
        </div>

        {reaffirmationState?.code === 404
            ? <div className="govuk-grid-row">
                <div className="govuk-grid-column-full">
                    <Alert className={styles.alert} data-testid="reaffirmationPage.alert" variant="info" >
                        <span className={['govuk-body govuk-!-font-weight-bold', styles.alertText].join(' ')}>
                            {reaffirmationState.message}
                        </span>
                    </Alert>
                </div>
            </div>
            : null
        }
        {(reaffirmationState?.code === 200)
            ? <div>
                <div className="govuk-grid-row">
                    <div className="govuk-grid-column-full">
                        <Notification data-testid="reaffirmationPage.notification" variant="success" header={intl.formatMessage({ id: 'reaffirmationPage.message.title' })}>
                            {intl.formatMessage({ id: 'reaffirmationPage.message.success.200.confirm' })}
                        </Notification>
                    </div>
                </div>
                <div className="govuk-grid-row">
                    <div className="govuk-grid-column-full">
                        <ButtonGroup className={styles.buttons}>
                            <Button
                                data-testid="reaffirmationPage.button.ok"
                                variant="success"
                                onPress={handleConfirmation}
                            >
                                {intl.formatMessage({ id: 'reaffirmationPage.message.button' })}
                            </Button>
                        </ButtonGroup>
                    </div>
                </div>
            </div>
            : null
        }
        {(reaffirmationState?.code === 403)
            ? <div>
                <div className="govuk-grid-row">
                    <div className="govuk-grid-column-full">
                        <Notification data-testid="reaffirmationPage.notification" variant="success" header={intl.formatMessage({ id: 'reaffirmationPage.message.title' })}>
                            {intl.formatMessage({ id: 'reaffirmationPage.message.success.403.confirm' })}
                        </Notification>
                    </div>
                </div>
                <div className="govuk-grid-row">
                    <div className="govuk-grid-column-full">
                        <ButtonGroup className={styles.buttons}>
                            <Button
                                data-testid="reaffirmationPage.button.ok"
                                variant="success"
                                onPress={handleConfirmation}
                            >
                                {intl.formatMessage({ id: 'reaffirmationPage.message.button' })}
                            </Button>
                        </ButtonGroup>
                    </div>
                </div>
            </div>
            : null
        }
    </Page>;
};

export default ReaffirmationPage;
